import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  GoogleSpreadsheetSelectorContainer, type GoogleSpreadsheetSelectorContainerProps,
} from './googleSpreadsheetSelector.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    GoogleSpreadsheetSelector: GoogleSpreadsheetSelectorContainerProps;
  }
}
modalRenderer.register('GoogleSpreadsheetSelector', GoogleSpreadsheetSelectorContainer);
